import { Container } from '@cgs/wge';
import { T_GameStateMachineNotifierComponent } from '../../../../type_definitions';
import {
  AbstractListener,
  GameStateMachineNotifierComponent,
} from '../../game_state_machine_notifier_component';
import { BreakerContext } from '../contexts/breaker_context';
import { IBreakeable } from '../progressive_breaker/ibreakeable';
import { IActionNodeStrategy } from './i_action_node_strategy';
import { GameStateMachineStates } from '../../../../reels_engine/state_machine/game-state-machine-states';

export class ProgressiveBreakerStrategy
  implements IActionNodeStrategy<BreakerContext>, AbstractListener
{
  private _container: Container;
  private _isStopAction: boolean;

  constructor(container: Container) {
    this._container = container;
    const notifierComponent = this._container.resolve<GameStateMachineNotifierComponent>(
      T_GameStateMachineNotifierComponent
    );
    notifierComponent.notifier.addListener(this);
  }

  performStrategy(actionContext: BreakerContext): void {
    if (this._isStopAction === true) {
      actionContext.breakeableProviders.forEach((item: any) => {
        const provider = this._container.resolve<IBreakeable>(item, { optional: true });
        if (provider) {
          provider.doBreak();
        }
      });
    }
  }

  onStateEntered(slotState: string): void {
    switch (slotState) {
      case GameStateMachineStates.Accelerate:
        this._isStopAction = false;
        break;
    }
  }

  onStateExited(slotState: string): void {
    switch (slotState) {
      case GameStateMachineStates.Stopping:
        this._isStopAction = true;
        break;
    }
  }
}
